<template>
  <div class="col-lg-8 col-md-12 footer-links">
    <h4>{{ $t("glink.title") }}</h4>

    <div v-if="isLoading">Loading...</div>

    <div v-else class="row row-cols-4 row-cols-md-5 row-cols-xl-6 g-3">
      <div
        v-for="(bookObject, index) in goodLinks"
        :key="index"
      >
        <div class="box">
          <a :href="bookObject.url" target="_blank">
            <img
              class="logo-img"
              :src="getImageUrl(bookObject.img)"
              :alt="bookObject.title"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "GoodLink",

  setup() {

    const goodLinks = ref([]);
    const isLoading = ref(true);

    const sheetID = "1HuF9n9XXL-WlCwSrEAC_UKZiu5ncxG4g6mYMCemeO1s";
    const sheetName = "GoodLink";

    const getImageUrl = (img) => {
      return `${process.env.BASE_URL}${img}`;
    };

    const formatData = (dataList) => {
      const headers = dataList[0];

      return dataList.slice(1).map((row) => {
        const obj = {};
        headers.forEach((header, i) => {
          obj[header] = row[i];
        });
        return obj;
      });
    };

    onMounted(async () => {

      const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/${sheetName}?alt=json&key=AIzaSyD21a6U3dc4wpee6BCu4D-pxnPff9QSW4w`;

      const res = await fetch(url);
      const data = await res.json();

      goodLinks.value = formatData(data.values);

      isLoading.value = false;

    });

    return {
      goodLinks,
      isLoading,
      getImageUrl
    };

  }
};
</script>

<style>
.box {
  display: flex;
  justify-content: center;
}

.logo-img {
  width: 90px;
  height: 90px;
  object-fit: contain;
  border-radius: 50%;
  background: #f2f2f2;
  padding: 10px;
  transition: 0.2s;
}

.logo-img:hover {
  transform: scale(1.05);
}
</style>